import { SafeHydrate } from "@/SafeHydrate";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookYourLavalService() {
  return <section data-section-id="252571" id="newsarchivecta" className="bg-background text-foreground py-20 md:py-32 border-t border-border">
      <div className="page-container flex flex-col items-center text-center">
        
        
        
        
        <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg h-14 px-8 sm:px-10 rounded-md shadow-lg transition-all" asChild>
          <Link to="/NewsArchivePage">
            <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
            TODAS LAS NOTICIAS
          </Link>
        </Button>
      </div>
    </section>;
}